<svelte:options
  customElement={{
    tag: 'teo-profile',
    extend: extendWithStyles,
  }}
/>

<script lang="ts">
  import type { TeoCore } from '@/teoCore/TeoCore';
  import { TeoProvider } from '@/utils/teo-context';

  import ProfileElement from '../lib/ui/components/auth/ProfileElement.svelte';
  import { extendWithStyles } from './web-component-utils';

  let { teoCore }: { teoCore?: TeoCore } = $props();
</script>

<TeoProvider {teoCore}>
  <ProfileElement />
</TeoProvider>
